// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetClaimIsNonTracked = () => false;

const updateClaimIsNonTracked = (state, action) => action.isNonTracked;

export default (state = getDefaultState().isNonTracked, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_PIP]: resetClaimIsNonTracked,
        [actions.UPDATE_CLAIM_PIP_IS_NON_TRACKED]: updateClaimIsNonTracked
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/pip/reducers/update-claim-is-non-tracked.js